import React from "react";
import { useLocation } from "react-router-dom";
import ThemePicker from "./ThemePicker";

export default function RouteThemePicker() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/app")) {
    return null;
  }
  return <ThemePicker variant="floating" />;
}
